/// <amd-module name="WidgetCommon/ConfigContracts/PullRequestsWidgetSettings" />
import { GitRepository } from "Repos/Common/Contracts/Git";
export interface PullRequestWidgetSettings {
    teamId: string;
    queryType: number;
    selectedRepos: GitRepository[] | undefined;
}
